import * as d3 from 'd3'

import draw_label from './draw-label'
import { guff } from '../utils/guff'

const transitionDuration = 300
const arc = d3.arc()

const layouts = [
    {
        n: 'top_left_back',
        back: true,
        level: 'top',
        hand: 'L',
        pivot: { x: 111, y: 71 },
        arm_label: { x: 155, y: 118, align: 'end' },
        num_label: { x: 155, y: 131, align: 'end' },
    },
    {
        n: 'top_right_front',
        back: false,
        level: 'top',
        hand: 'R',
        pivot: { x: 111, y: 71 },
        arm_label: { x: 155, y: 118, align: 'end' },
        num_label: { x: 155, y: 131, align: 'end' },
    },
    {
        back: true,
        n: 'mid_left_back',
        level: 'middle',
        hand: 'L',
        pivot: { x: 108, y: 80 },
        arm_label: { x: 158, y: 118, align: 'end' },
        num_label: { x: 158, y: 131, align: 'end' },
    },
    {
        back: false,
        n: 'mid_right_front',
        level: 'middle',
        hand: 'R',
        pivot: { x: 108, y: 80 },
        arm_label: { x: 158, y: 118, align: 'end' },
        num_label: { x: 158, y: 131, align: 'end' },
    },
    {
        back: true,
        n: 'low_left_back',
        level: 'low',
        hand: 'L',
        pivot: { x: 102, y: 88 },
        player_nudge: { x: 6, y: 0 },
        arm_label: { x: 160, y: 118, align: 'end' },
        num_label: { x: 160, y: 131, align: 'end' },
    },
    {
        back: false,
        n: 'low_right_front',
        level: 'low',
        hand: 'R',
        pivot: { x: 102, y: 88 },
        player_nudge: { x: 6, y: 0 },
        arm_label: { x: 160, y: 118, align: 'end' },
        num_label: { x: 160, y: 131, align: 'end' },
    },
    {
        back: true,
        n: 'top_right_back',
        level: 'top',
        hand: 'R',
        pivot: { x: 103, y: 71 },
        player_nudge: { x: 10, y: 0 },
        arm_label: { x: 84, y: 117, align: 'end' },
        num_label: { x: 84, y: 131, align: 'end' },
    },
    {
        back: false,
        n: 'top_left_front',
        level: 'top',
        hand: 'L',
        pivot: { x: 103, y: 71 },
        player_nudge: { x: 10, y: 0 },
        arm_label: { x: 84, y: 117, align: 'end' },
        num_label: { x: 84, y: 131, align: 'end' },
    },
    {
        back: true,
        n: 'mid_right_back',
        level: 'middle',
        hand: 'R',
        pivot: { x: 99, y: 80 },
        player_nudge: { x: 10, y: 0 },
        arm_label: { x: 50, y: 117, align: 'start' },
        num_label: { x: 76, y: 131, align: 'end' },
    },
    {
        back: false,
        n: 'mid_left_front',
        level: 'middle',
        hand: 'L',
        pivot: { x: 99, y: 80 },
        player_nudge: { x: 10, y: 0 },
        arm_label: { x: 50, y: 117, align: 'start' },
        num_label: { x: 76, y: 131, align: 'end' },
    },
    {
        back: true,
        n: 'low_right_back',
        level: 'low',
        hand: 'R',
        pivot: { x: 102, y: 87 },
        arm_label: { x: 43, y: 117, align: 'start' },
        num_label: { x: 69, y: 131, align: 'end' },
    },
    {
        back: false,
        n: 'low_left_front',
        level: 'low',
        hand: 'L',
        pivot: { x: 102, y: 87 },
        arm_label: { x: 43, y: 117, align: 'start' },
        num_label: { x: 69, y: 131, align: 'end' },
    },
]

const picker = d3.scaleThreshold([5, 41], ['low', 'middle', 'top'])

export const cardSVGWidth = 120
export const cardSVGHeight = 140

class LittleMan {
    initialized = false

    armAngleEls = []

    back = true

    // hackkkkk
    player = false

    highlighted = ''

    multi = false

    constructor(el, opts = {}) {
        this.el = el

        this.player = opts.player ?? false
        this.handleHighlight = opts.handleHighlight ?? false
        this.handleAngleClick = opts.handleAngleClick ?? false
        this.handleMultiClick = opts.handleMultiClick ?? false
        this.colorFn = opts.colorFn || (() => 'black')
        this.formatFn =
            opts.formatFn || ((angle) => `${guff(angle, 'arm_angle_viz')}°`)
        this.formatMulti =
            opts.formatMulti || ((row) => row.api_pitch_type_group03)
        this.formatMultiHover = opts.formatMultiHover || this.formatMulti
        this.multi = Boolean(opts.multi)

        this.setup()
    }

    setup() {
        // Setup all the relevant elements
        this.image = this.el
            .append('image')
            .attr('width', '150')
            .attr('height', '150')
            .attr('x', '0')
            .attr('y', '0')

        this.armAngleText = this.el.append('g')

        this.setupArm()
    }

    getXOffset() {
        let xOffset = -60
        if (this.back) {
            if (this.pitchHand === 'R' && this.avgArmAngle < 5) {
                xOffset = -30
            } else if (this.pitchHand === 'R') {
                xOffset = -40
            }
        } else if (this.pitchHand === 'L' && this.avgArmAngle < 5) {
            xOffset = -30
        } else if (this.pitchHand === 'L') {
            xOffset = -40
        }

        if (this.layout.player_nudge) {
            xOffset = this.layout.player_nudge.x + xOffset
        }

        return xOffset
    }

    setLayout() {
        this.layout = layouts.find(
            (d) =>
                picker(this.avgArmAngle) === d.level &&
                this.pitchHand === d.hand &&
                this.back === d.back
        )

        if (!this.layout) {
            this.el.style('display', 'none')
            this.initialized = false
        }
    }

    calculateAverages() {
        this.totalPitches = this.angles.reduce(
            (acc, curr) => acc + curr.n_pitches,
            0
        )

        this.avgArmAngle = this.angles.reduce(
            (acc, curr) =>
                acc + (curr.arm_angle * curr.n_pitches) / this.totalPitches,
            0
        )
    }

    update(angles, isBack = true) {
        if (!angles.length || !angles?.[0]) {
            this.el.style('display', 'none')
            this.initialized = false
            return
        }

        this.back = isBack

        const { pitch_hand: pitchHand } = angles?.[0] || {}

        this.pitchHand = pitchHand
        // Optional

        this.angles = angles
        this.calculateAverages()
        this.setLayout()

        if (!this.layout) {
            this.el.style('display', 'none')
            this.initialized = false
            return
        }

        this.display()
    }

    display() {
        const xOffset = this.getXOffset()

        this.el
            .attr('transform', `translate(${xOffset}, -5)`)
            .style('display', 'inline')

        this.updateImage()

        this.updateArm()

        if (this.angles.length > 1 || this.multi) {
            this.updateArmTextMulti()
            this.removeArmAngleValue()
        } else {
            this.updateArmAngleText()
            this.updateArmAngleValue()
        }
    }

    flip() {
        this.back = !this.back

        this.setLayout()

        this.display()
    }

    updateImage() {
        this.image.attr(
            'xlink:href',
            `/sections/player-update/images/arm-angles/SavantPitchers_${this.layout.n}.svg`
        )
    }

    updateArmAngleText() {
        this.armAngleEls.forEach((el) => {
            d3.select(el).remove()
        })
        // Because this could be multiple elements, it's simply easier to nuke it and redo
        this.armAngleEls = draw_label({
            thetext: `ARM ANGLE`,
            svg: this.armAngleText.node(),
            fillColor: 'rgb(104, 146, 162)',
            fontSize: 10,
            fontWeight: 'normal',
            fontFamily: 'Roboto Condensed',
            x: this.layout.arm_label.x,
            y: this.layout.arm_label.y,
            textAnchor: this.layout.arm_label.align,
            wrap_width: this.layout.arm_label.width || 20,
            wrap_line_height: 10,
            wrap_direction: 'up',
        })
    }

    removeArmAngleValue() {
        this.armAngleValueEl?.remove()
    }

    updateArmAngleValue() {
        // Draw label if label doesn't exist (first time called)
        if (!this.armAngleValueEl) {
            // eslint-disable-next-line prefer-destructuring
            this.armAngleValueEl = draw_label({
                thetext: String(this.formatFn(this.avgArmAngle)),
                svg: this.el.node(),
                fillColor: 'black',
                fontSize: 14,
                fontFamily: 'Roboto Condensed',
                x: this.layout.num_label.x,
                y: this.layout.num_label.y,
                textAnchor: this.layout.num_label.align,
            })[0]
        } else {
            // Otherwise tween update
            d3.select(this.armAngleValueEl)
                .attr('text-anchor', this.layout.num_label.align)
                .attr('x', this.layout.num_label.x)
                .attr('y', this.layout.num_label.y)
                .transition()
                .duration(transitionDuration)
                .tween('text', (d, i, group) => {
                    const selection = d3.select(group[i])
                    const start = Number(selection.text().replace('°', '') || 0)
                    const end = this.avgArmAngle

                    const interpolator = d3.interpolateNumber(start, end)

                    return (t) => {
                        let angle = guff(interpolator(t), 'arm_angle_viz')

                        if (Number.isNaN(angle)) {
                            angle = Math.round(end)
                        }
                        if (Number.isNaN(angle)) {
                            // Well we tried hard, time to give up
                            return selection.text('')
                        }

                        return selection.text(`${angle}°`)
                    }
                })
        }
    }

    updateArm() {
        const [min, max] = d3.extent(this.angles, (d) => d.arm_angle)
        this.armWrapperEl2.attr(
            'transform',
            `translate(${this.layout.pivot.x},${this.layout.pivot.y})`
        )

        let { startAngle, endAngle, flip } = this.getRotationInfo(
            this.pitchHand,
            max
        )

        if (min < 0) {
            if (max > 0) {
                startAngle = endAngle
            }

            const oppRotation = this.getRotationInfo(this.pitchHand, min)
            endAngle = oppRotation.endAngle
        }

        this.armWrapperEl2.select('path.little-man-arm-arc').attr(
            'd',
            arc({
                innerRadius: 0,
                outerRadius: 15,
                startAngle,
                endAngle,
            })
        )

        const endPoint = flip ? 20 : -20

        // The line under the arc
        this.armWrapperEl2
            .select('polyline.little-man-arm-axis')
            .attr('points', `0,0 ${endPoint},0`)

        const opacity = this.angles.length > 1 ? 0.7 : 1

        this.armWrapperEl2
            .selectAll('g.little-arm')
            .data(this.angles, (d) => d.id)
            .join(
                (enter) => {
                    const el = enter
                        .append('g')
                        .attr('id', (d) => `viz-lil-arm-${d.id}`)
                        .classed('little-arm', true)
                        .attr('transform', (d) => {
                            const { rotation } = this.getRotationInfo(
                                d.pitch_hand,
                                d.arm_angle
                            )
                            return `rotate(${rotation})`
                        })
                        .attr('opacity', (d) => {
                            if (this.highlighted) {
                                return this.highlighted === d.id ? 1 : 0
                            }

                            return opacity
                        })

                    // The "Arm" itself
                    const armEl = el.append('g').attr('class', 'little-man-arm')

                    armEl
                        .append('polygon')
                        .attr('points', '2,2 -2,2 -0.2,-30, 0.2,-30 2,2')
                        .attr('stroke', 'black')
                        .attr('stroke-width', 2)
                        .attr('stroke-linejoin', 'round')

                    armEl
                        .append('circle')
                        .attr('transform', `translate(0,-30)`)
                        .attr('r', 2)
                        .attr('stroke', 'black')
                        .attr('fill', `white`)
                        .attr('stroke-width', `1.5`)
                        .attr('stroke', this.colorFn)
                        .attr('fill', 'white')

                    return el
                },
                (update) => {
                    update
                        .transition()
                        .attr('opacity', (d) => {
                            if (this.highlighted) {
                                return this.highlighted === d.id ? 1 : 0
                            }

                            return opacity
                        })
                        .attr('transform', (d) => {
                            const { rotation } = this.getRotationInfo(
                                d.pitch_hand,
                                d.arm_angle
                            )
                            return `rotate(${rotation})`
                        })

                    update
                        .select('circle')
                        .attr('stroke', this.colorFn)
                        .attr('fill', 'white')
                    return update
                }
            )
    }

    updateArmTextMulti() {
        const xOffset = this.getXOffset()

        const { num_label } = this.layout
        const leftish =
            (this.back && this.pitchHand === 'L') ||
            (!this.back && this.pitchHand === 'R')
        // Undo offset
        const x = leftish ? 120 - xOffset - 10 : -xOffset + 10

        const maxCols = 6

        const colSize = leftish ? -20 : 20

        this.armAngleText.attr('transform', `translate(${x}, ${num_label.y})`)
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this
        const opacity = this.angles.length > 1 ? 0.5 : 1
        this.armAngleText
            .selectAll('g.group-pitches')
            .data(this.angles, (d) => d.id)
            .join(
                (enter) => {
                    const el = enter
                        .append('g')
                        .classed('group-pitches', true)
                        .attr('transform', (d, i) => {
                            const xVal = Math.floor(i / maxCols) * colSize
                            const yVal = (i % maxCols) * -14
                            return `translate(${xVal}, ${yVal})`
                        })
                        .style(
                            'cursor',
                            this.handleMultiClick ? 'pointer' : 'auto'
                        )
                        .on('mouseover', function handleMouseover(e, d) {
                            d3.select(this)
                                .select('text')
                                .text(that.formatMultiHover(d))
                                .attr('opacity', 1)
                            that.highlightArm(d.id)
                        })
                        .on('mouseout', function handleMouseout(e, d) {
                            d3.select(this)
                                .select('text')
                                .text(that.formatMulti(d))
                                .attr('opacity', opacity)
                            that.highlightArm('')
                        })
                        .on('click', (e, d) => {
                            if (this.handleMultiClick) {
                                this.handleMultiClick(d)
                            }
                        })

                    el.append('rect')
                        // This is set for the years width. If we have other options, it might not work as well.
                        .attr('width', 28)
                        .attr('height', 12)
                        .attr('fill', 'transparent')
                        .attr('y', -10)
                        .attr('x', leftish ? -27 : -1)

                    el.append('text')
                        .text(this.formatMulti)
                        .style('pointer-events', 'none')
                        .attr('text-anchor', leftish ? 'end' : 'start')
                        .attr('font-size', 12)
                        .attr('fill', this.colorFn)
                        .attr('opacity', (d) => {
                            if (this.highlighted) {
                                return this.highlighted === d.id ? 1 : 0.2
                            }

                            return opacity
                        })

                    return el
                },
                (update) => {
                    update
                        .transition()
                        .attr('opacity', (d) => {
                            if (this.highlighted) {
                                return this.highlighted === d.id ? 1 : 0.2
                            }

                            return opacity
                        })
                        .text(this.formatMulti)
                        .attr('fill', this.colorFn)

                    return update
                }
            )
    }

    setupArm() {
        // Bastardized Version
        this.armWrapperEl2 = this.el
            .append('g')
            .attr('class', 'little-man-arm-wrapper')

        this.armWrapperEl2
            .append('path')
            .attr('class', 'little-man-arm-arc')
            .attr('fill', '#E2E8E7')

        // The line under the arc
        this.armWrapperEl2
            .append('polyline')
            .attr('class', 'little-man-arm-axis')
            .attr('stroke-width', '0.6')
            .attr('stroke', 'rgb(95, 134, 153)')
    }

    getRotationInfo(pitchHand, ballAngle) {
        const flip =
            (pitchHand === 'R' && this.back) ||
            (pitchHand === 'L' && !this.back)

        const rotation = flip ? 90 - ballAngle : -90 + ballAngle

        const startAngle = flip ? (90 * Math.PI) / 180 : (-90 * Math.PI) / 180

        const endAngle = flip
            ? (90 - ballAngle) * (Math.PI / 180)
            : (-90 + ballAngle) * (Math.PI / 180)

        return { flip, rotation, startAngle, endAngle }
    }

    highlightArm(id) {
        this.highlighted = id

        this.updateArm()

        if (this.handleHighlight) {
            this.handleHighlight(id, this.angles)
        }
    }
}

export default LittleMan
